export default __webpack_public_path__ + "static/media/logo_white.df916fa8.png";